import React from "react";
import { useNavigate } from "react-router-dom";
import { Drawer, List, ListItem, ListItemIcon, ListItemText, Divider, Typography } from "@mui/material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PhoneIcon from "@mui/icons-material/Phone";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import UfoneLogo from "../img/ufone.jpg";



const Sidebar = ({ selectedItem, onSelect }) => {
  const menuItems = [
    { text: "Dashboard", icon: <DashboardIcon />, value: "dashboard" },
    { text: "Logout", icon: <ExitToAppIcon />, value: "logout" },
  ];
  const navigate = useNavigate();
  

  const handleItemClick = (value) => {
    if (value=='logout') 
    {
    localStorage.removeItem("authToken");
    localStorage.removeItem("tokenExpiry");
    navigate('/login')
    }
    else if(value=='dashboard')
    {
    navigate('/')
    }

  };
  

  return (
    <Drawer
      variant="permanent"
      anchor="left"
      style={{ width: "240px", flexShrink: 0 }}
      PaperProps={{ style: { width: "240px",backgroundColor:"rgb(255, 255, 255)" } }}
    >
      <div style={{ padding: "20px", textAlign: "center" }}>
        <Typography variant="h10" color="rgb(234, 127, 47)">
          Ufone Customer Care Portal
        </Typography>
        <img
          src={UfoneLogo}
          alt="Ufone Logo"
          style={{ maxWidth: "80%", height: "auto", marginBottom: "10px" }}
        />
      </div>
      <Divider />
      <List>
        {menuItems.map((item) => (
          <ListItem
            button
            key={item.text}
            selected={selectedItem === item.value}
            onClick={() => handleItemClick(item.value)}
          >
            <ListItemIcon>{item.icon}</ListItemIcon>
            <ListItemText primary={item.text} />
          </ListItem>
        ))}
      </List>
    </Drawer>
  );
};

export default Sidebar;
